export default __webpack_public_path__ + "static/media/zahrada2.41955aa4.jpeg";